// // useMoneyMarketAccruals.ts
// import { useState, useEffect, useMemo } from "react";
// import moment from "moment";
// import { toast } from "react-toastify";
// import {
//   getFundByAmc,
//   validateFundNav,
// } from "../../stores/services/funds.service";
// import { addMegaTransaction } from "../../stores/services/beta-transaction.service";
// import { getTransactionsLedgers } from "../../stores/services/chatofaccounts.service";
// import { getPortfolioByDate } from "../../stores/services/daily-unrealized-portfolio.service";
// import { numberWithCommas as formatNumberWithCommas } from "../../utils/customFunction";
// import {
//   Calculations,
//   MoneyMarketItem,
//   ProcessedLedgerEntry,
//   SecurityType,
// } from "./types";
// import { useHistory } from "react-router-dom";
// import { SecurityArr } from "../../utils/ui_data";

// const useMoneyMarketAccruals = (email: string, amc_code: string) => {
//   const history = useHistory();
//   const [loading, setLoading] = useState<boolean>(false);
//   const [accFundLoading, setAccFundLoading] = useState<boolean>(false);
//   const [allFunds, setAllFunds] = useState<any[]>([]);
//   const [fund, setFund] = useState<string>("");
//   const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"));
//   const [portfolioDate, setPortfolioDate] = useState<string>(
//     moment().format("YYYY-MM-DD")
//   );
//   const [tableData, setTableData] = useState<MoneyMarketItem[]>([]);
//   const [calculations, setCalculations] = useState<Calculations>({});
//   const [transactionLedgers, setTransactionLedgers] = useState<any[]>([]);
//   const [affectedLedgerData, setAffectedLedgerData] = useState<
//     ProcessedLedgerEntry[]
//   >([]);
//   const [sendingLedgers, setSendingLedgers] = useState<ProcessedLedgerEntry[]>(
//     []
//   );
//   const [fundCheck, setFundCheck] = useState<boolean>(false);
//   const [selectedMarket, setSelectedMarket] = useState<string>("");
//   const [todayPIBTotal, setTodayPIBTotal] = useState<number>(0);
//   const [todayTBILLTotal, setTodayTBILLTotal] = useState<number>(0);
//   const [todayTFCTotal, setTodayTFCTotal] = useState<number>(0);
//   const [todaySUKUKTotal, setTodaySUKUKTotal] = useState<number>(0);
//   const [finalPIB, setFinalPIB] = useState<number>(0);
//   const [finalTBILL, setFinalTBILL] = useState<number>(0);
//   const [finalTFC, setFinalTFC] = useState<number>(0);
//   const [finalSUKUK, setFinalSUKUK] = useState<number>(0);

//   useEffect(() => {
//     if (amc_code) {
//       getFundByAMcCode(amc_code);
//     }
//     loadTransactionLedgers();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [email, amc_code]);

//   const getFundByAMcCode = async (code: string) => {
//     setAccFundLoading(true);
//     try {
//       const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
//       const response = await getFundByAmc(
//         email,
//         code,
//         fund_code?.length > 0 ? fund_code : ""
//       );
//       const sortedData = [...(response.data?.data || [])].sort((a, b) =>
//         (a.nature || "").toLowerCase() < (b.nature || "").toLowerCase() ? -1 : 1
//       );
//       setAllFunds(sortedData);
//       setFundCheck(sortedData.length < 1);
//     } catch (error: any) {
//       toast.error(
//         error?.response?.data?.message ||
//         error?.message ||
//         "Error fetching funds"
//       );
//     } finally {
//       setAccFundLoading(false);
//     }
//   };

//   const loadTransactionLedgers = async () => {
//     try {
//       const txnResponse = await getTransactionsLedgers(email);
//       if (txnResponse?.data?.status === 200) {
//         const unitManagement =
//           txnResponse.data.data.txn_catagory[4]?.portfolioTxn || [];
//         const txnLedgers = unitManagement.filter(
//           (item: any) => item.api_name === "dailyportfolioaccrual"
//         );
//         setTransactionLedgers(txnLedgers);
//       } else {
//         toast.error("Failed to load transaction ledgers");
//       }
//     } catch (err: any) {
//       console.error("Error loading ledgers:", err);
//       toast.error(err?.message || "Failed to load transaction ledgers");
//     }
//   };

//   const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setDate(e.target.value);
//     resetState();
//   };

//   const resetState = () => {
//     setTableData([]);
//     setCalculations({});
//     setAffectedLedgerData([]);
//     setSendingLedgers([]);
//     setTodayPIBTotal(0);
//     setTodayTBILLTotal(0);
//     setTodayTFCTotal(0);
//     setTodaySUKUKTotal(0);
//     setFinalPIB(0);
//     setFinalTBILL(0);
//     setFinalTFC(0);
//     setFinalSUKUK(0);
//   };

//   // 🔢 Core calculation and ledger generation
//   const recalculateLedgers = (data: MoneyMarketItem[]) => {
//     const tempCalculations: Calculations = {};
//     const affectedTemp: ProcessedLedgerEntry[] = [];
//     const sendingTemp: ProcessedLedgerEntry[] = [];

//     data.forEach((item) => {
//       const maturityMoment = moment(item?.maturity_date).startOf('day');
//       const currentMoment = moment(date).startOf('day');
//       const daysofMaturity = maturityMoment.diff(currentMoment, 'days');
//       const type = item.security_type as SecurityType;
//       let accrual = 0;
//       switch (type) {
//         case "PIB":
//           const totalfaceValue = parseFloat(item?.total_face_value || "0");
//           const couponRatePIB = parseFloat(item?.coupon_rate || "0") / 100;
//           const couponPaymentPIB = parseFloat(item.coupon_payment || "1");
//           const couponDaysPIB = parseFloat(item.coupon_days || "365");
//           if (couponDaysPIB > 0) {
//             accrual = (totalfaceValue * (couponRatePIB / couponPaymentPIB)) / couponDaysPIB
//           }
//           // tempCalculations[type] = accrual;
//           tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
//           break;
//         case "TDR":
//         case "LOP":
//         case "CP":
//         case "CDR":
//           const principalAmmountCDR = parseFloat(item?.principal_amount || "0");
//           const interestRateCDR = parseFloat(item?.yield || "0") / 100;
//           accrual = (principalAmmountCDR * interestRateCDR) / 365
//           // tempCalculations[type] = accrual;
//           tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
//           break;
//         case "TFC":
//         case "Bai Mujjal Placement":
//         case "SUKUK":
//           const unredeem = parseFloat(
//             item.unredeem_value || item.total_face_value || "0"
//           );
//           const couponRate = parseFloat(item.coupon_rate || "0") / 100;
//           const couponPayment = parseFloat(item.coupon_payment || "1");
//           const couponDays = parseFloat(item.coupon_days || "365");
//           if (couponDays > 0) {
//             accrual = (unredeem * (couponRate / couponPayment)) / couponDays;
//           }
//           tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
//           break;
//         case "TBILL":
//           const faceValue = parseFloat(item.total_face_value || "0");
//           const cost = parseFloat(item.total_amount || "0");
//           if (+daysofMaturity > 0) {
//             accrual = (faceValue - cost) / daysofMaturity;
//           }
//           // const maturityDays = parseFloat(item.days_of_maturity || "1");
//           // if (maturityDays > 0) {
//           //   accrual = (faceValue - cost) / maturityDays;
//           // }
//           // tempCalculations[type] = accrual;
//           tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
//           break;

//         default:
//           break;
//       }
//     });

//     // Round and set totals
//     Object.keys(tempCalculations).forEach((key) => {
//       const k = key as SecurityType;
//       tempCalculations[k] = parseFloat(tempCalculations[k]!.toFixed(4));
//     });

//     setTodayPIBTotal(tempCalculations["PIB"] || 0);
//     setTodayTBILLTotal(tempCalculations["TBILL"] || 0);
//     setTodayTFCTotal(tempCalculations["TFC"] || 0);
//     setTodaySUKUKTotal(tempCalculations["SUKUK"] || 0);

//     setFinalPIB(tempCalculations["PIB"] || 0);
//     setFinalTBILL(tempCalculations["TBILL"] || 0);
//     setFinalTFC(tempCalculations["TFC"] || 0);
//     setFinalSUKUK(tempCalculations["SUKUK"] || 0);

//     // Rebuild ledgers
//     affectedTemp.length = 0;
//     sendingTemp.length = 0;

//     Object.keys(tempCalculations).forEach((typeKey) => {
//       const type = typeKey as SecurityType;
//       const amount = tempCalculations[type];
//       if (amount !== undefined && Math.abs(amount) > 0.0001) {
//         processSecurityLedgers(
//           type,
//           amount,
//           transactionLedgers,
//           affectedTemp,
//           sendingTemp,
//           { fund_code: fund, settlement_date: date },
//           amc_code,
//           fund
//         );
//       }
//     });
//     setCalculations(tempCalculations);
//     setAffectedLedgerData(affectedTemp);
//     setSendingLedgers(sendingTemp);
//   };

//   const handleGet = async () => {
//     if (!fund) return toast.error("Please select a fund.");

//     setLoading(true);
//     resetState();

//     try {
//       const response = await getPortfolioByDate(
//         email,
//         amc_code,
//         fund,
//         portfolioDate
//       );
//       if (response?.data?.status === 404)
//         return toast.error("No record found for Today");
//       if (response?.data?.status !== 200) throw new Error("Fetch failed");

//       const marketKey = selectedMarket === "money_market" ? "money_market" : "stock_market";
//       const marketData = JSON.parse(response.data.data[0]?.[marketKey] || "[]");
//       const filterData =
//         selectedMarket === "money_market" ?
//           marketData?.filter((ele) => {
//             if ((ele?.security_type === "CP" || ele?.security_type === "TDR" || ele?.security_type === "CDR" || ele?.security_type === "LOP") && ele?.principal_amount > 0) {
//               return true
//             }
//             else if (ele?.units > 0) {
//               return true
//             }
//             else {
//               return false
//             }
//           }) :
//           marketData;

//       if (!filterData.length) {
//         return toast.error("No data found for the selected date!");
//       }

//       // const moneyMarket = JSON.parse(
//       //   response.data.data[0]?.money_market || "[]"
//       // );
//       // if (!moneyMarket.length)
//       //   return toast.error("No data found for selected date!");

//       setTableData([...filterData]);
//       recalculateLedgers(filterData); // Initial ledger calculation
//     } catch (err: any) {
//       toast.error(err?.message || "Failed to load data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✏️ Update coupon rate for a specific index
//   const updateCouponRate = (index: number, value: string) => {
//     const numValue = parseFloat(value);
//     if (isNaN(numValue) || numValue < 0 || numValue > 100) return;

//     setTableData((prev) => {
//       const updated = [...prev];
//       updated[index] = { ...updated[index], coupon_rate: numValue.toFixed(4) };
//       return updated;
//     });
//   };

//   // 🗑️ Remove security by index
//   const removeSecurityAtIndex = (index: number) => {
//     setTableData((prev) => prev.filter((_, i) => i !== index));
//   };

//   // 🔄 Recalculate whenever tableData changes
//   useEffect(() => {
//     if (tableData.length > 0 && fund) {
//       recalculateLedgers(tableData);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tableData, fund]);

//   // 💾 Submit handler
//   const handleSubmit = async () => {
//     if (sendingLedgers.length === 0) return toast.error("No data to submit");

//     setLoading(true);

//     // Calculate net_amount by summing all credit amounts from sendingLedgers
//     const totalNetAmount = sendingLedgers.reduce((sum, ledger) => {
//       const credit = parseFloat(ledger.credit_amount) || 0;
//       return sum + credit;
//     }, 0);

//     const fields = {
//       amc_code,
//       fund_code: fund,
//       settlement_date: date,
//       txnr_type: "dailyportfolioaccrual",
//       instruction_date: moment(date).format("YYYY-MM-DD"),
//       execution_date: moment(date).format("YYYY-MM-DD"),
//       realized_date: moment(date).format("YYYY-MM-DD"),
//       realized: "true",
//       email,
//       period: sessionStorage.getItem("active_period") || "",
//       net_amount: String(totalNetAmount.toFixed(4)), // ✅ Dynamically calculated
//       ledgers: JSON.stringify(sendingLedgers),
//     };

//     try {
//       const navCheck = await validateFundNav(email, amc_code, fund, date);
//       if (navCheck?.data?.status !== 200) {
//         return toast.error(navCheck?.data?.message);
//       }

//       const result = await addMegaTransaction(fields);
//       if (result.data.status === 200) {
//         sessionStorage.setItem("last_id", result.data.txn_id);
//         toast.success("Transaction added successfully!");
//         setSendingLedgers([]);
//         setAffectedLedgerData([]);
//         setTableData([]);
//         setTimeout(() => history.push("/admin/recent-transactions"), 500);
//       } else {
//         toast.warning(result.data.message);
//       }
//     } catch (error: any) {
//       toast.error(error?.message || "Submission failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePortfolioDate = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setLoading(true);

//     setPortfolioDate(e.target.value);
//     setLoading(false);
//   };

//   // 🔗 Process ledger entries
//   const processSecurityLedgers = (
//     type: SecurityType,
//     amount: number,
//     ledgersConfig: any[],
//     affectedTemp: ProcessedLedgerEntry[],
//     sendingTemp: ProcessedLedgerEntry[],
//     fields: { fund_code: string; settlement_date: string },
//     amcCode: string,
//     fundCode: string
//   ) => {
//     const config = ledgersConfig.find(
//       (item) => item.security === type && item.payment_type === "Receipt"
//     );
//     if (!config) return;

//     const debitLedger = config.ledgers?.find((l: any) => l.type === "Debit");
//     const creditLedger = config.ledgers?.find((l: any) => l.type === "Credit");
//     if (!debitLedger || !creditLedger) return;

//     const absAmount = Math.abs(amount).toFixed(4);
//     const desc = `${type} Accrual`;

//     const newDebit: ProcessedLedgerEntry = getLedgerEntry(
//       { amcCode, fundCode, date, absAmount, email, desc },
//       debitLedger,
//       "debit"
//     );
//     const newCredit: ProcessedLedgerEntry = getLedgerEntry(
//       { amcCode, fundCode, date, absAmount, email, desc },
//       creditLedger,
//       "credit"
//     );

//     affectedTemp.push(newDebit, newCredit);
//     sendingTemp.push(newDebit, newCredit);
//   };

//   const renderFundsDropdown = useMemo(
//     () =>
//       allFunds.map((item) => ({
//         value: item.symbol_code,
//         label: `${item.fund_name} (${item.symbol_code})${item.nature === "Special Managed Account" ? ' - {"SMA"}' : ""
//           }`,
//       })),
//     [allFunds]
//   );

//   const selectedFundName = useMemo(
//     () => renderFundsDropdown.find((f: any) => f.value === fund) || null,
//     [fund, renderFundsDropdown]
//   );
//   const selectedMarketVal = useMemo(
//     () => SecurityArr?.find((f: any) => f.value === selectedMarket) || null,
//     [selectedMarket]
//   );

//   return {
//     loading,
//     accFundLoading,
//     allFunds,
//     fund,
//     setSelectedMarket,
//     selectedMarket,
//     selectedMarketVal,
//     setFund,
//     date,
//     portfolioDate,
//     handleDateChange,
//     resetState,
//     tableData,
//     calculations,
//     affectedLedgerData,
//     sendingLedgers,
//     fundCheck,
//     todayPIBTotal,
//     todayTBILLTotal,
//     todayTFCTotal,
//     todaySUKUKTotal,
//     finalPIB,
//     finalTBILL,
//     finalTFC,
//     finalSUKUK,
//     handleGet,
//     handleSubmit,
//     renderFundsDropdown,
//     selectedFundName,
//     numberWithCommas: (val: number | string) =>
//       formatNumberWithCommas(parseFloat(val.toString()).toFixed(4)),
//     updateCouponRate,
//     removeSecurityAtIndex,
//     handlePortfolioDate,
//   };
// };

// const getLedgerEntry = (
//   relatedData: any,
//   data: any,
//   type: "debit" | "credit"
// ) => {
//   return {
//     account_number: "",
//     account_title: "",
//     amc_code: relatedData.amcCode,
//     bank_code: "",
//     branch: "",
//     child_family_code: data.ledger_root?.[0]?.child_family_code || "",
//     child_family_name: data.ledger_root?.[0]?.child_family_name || "",
//     counter_account_number: "",
//     counter_account_title: "",
//     counter_bank: "",
//     counter_branch: "",
//     created_at: "",
//     credit_amount: type === "credit" ? relatedData.absAmount : "0",
//     debit_amount: type === "debit" ? relatedData.absAmount : "0",
//     description: relatedData.desc,
//     doc_type: "",
//     entered_by: relatedData.email,
//     evidence: "",
//     family_code: data.ledger_root?.[0]?.family_code || "",
//     family_name: data.ledger_root?.[0]?.family_name || "",
//     fund_code: relatedData.fundCode,
//     gl_code: data.ledger_root?.[0]?.gl_code || "",
//     gl_name: data.ledger_root?.[0]?.gl_name || "",
//     instruction_date: moment(relatedData.date).format("YYYY-MM-DD"),
//     instrument_by: "",
//     instrument_date: moment(relatedData.date).format("YYYY-MM-DD"),
//     instrument_no: "",
//     instrument_type: "",
//     main_family_code: data.ledger_root?.[0]?.main_family_code || "",
//     main_family_name: data.ledger_root?.[0]?.main_family_name || "",
//     realized: "true",
//     realized_by: "",
//     realized_date: moment(relatedData.date).format("YYYY-MM-DD"),
//     sub_family_code: data.ledger_root?.[0]?.sub_family_code || "",
//     sub_family_name: data.ledger_root?.[0]?.sub_family_name || "",
//   };
// };

// export default useMoneyMarketAccruals;

// usePortfolioAccrual.ts
import { useState, useEffect, useMemo } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import {
  getFundByAmc,
  validateFundNav,
} from "../../stores/services/funds.service";
import { addMegaTransaction } from "../../stores/services/beta-transaction.service";
import {
  getNewChartsOfAccountsByFund,
  getTransactionsLedgers,
} from "../../stores/services/chatofaccounts.service";
import { getPortfolioByDate } from "../../stores/services/daily-unrealized-portfolio.service";
import {
  numberWithCommas as formatNumberWithCommas,
  getLedgerInfoByLedgerCodeWorking,
} from "../../utils/customFunction";
import {
  Calculations,
  MoneyMarketItem,
  ProcessedLedgerEntry,
  SecurityType,
} from "./types";
import { useHistory } from "react-router-dom";
import { SecurityArr } from "../../utils/ui_data";

const usePortfolioAccrual = (email: string, amc_code: string) => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [accFundLoading, setAccFundLoading] = useState<boolean>(false);
  const [allFunds, setAllFunds] = useState<any[]>([]);
  const [fund, setFund] = useState<string>("");
  const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"));
  const [portfolioDate, setPortfolioDate] = useState<string>(
    moment().format("YYYY-MM-DD")
  );
  const [tableData, setTableData] = useState<MoneyMarketItem[]>([]);
  const [calculations, setCalculations] = useState<Calculations>({});
  const [transactionLedgers, setTransactionLedgers] = useState<any[]>([]);
  const [affectedLedgerData, setAffectedLedgerData] = useState<
    ProcessedLedgerEntry[]
  >([]);
  const [sendingLedgers, setSendingLedgers] = useState<ProcessedLedgerEntry[]>(
    []
  );
  const [fundCheck, setFundCheck] = useState<boolean>(false);
  const [selectedMarket, setSelectedMarket] = useState<string>("");
  const [todayPIBTotal, setTodayPIBTotal] = useState<number>(0);
  const [todayTBILLTotal, setTodayTBILLTotal] = useState<number>(0);
  const [todayTFCTotal, setTodayTFCTotal] = useState<number>(0);
  const [todaySUKUKTotal, setTodaySUKUKTotal] = useState<number>(0);
  const [finalPIB, setFinalPIB] = useState<number>(0);
  const [finalTBILL, setFinalTBILL] = useState<number>(0);
  const [finalTFC, setFinalTFC] = useState<number>(0);
  const [finalSUKUK, setFinalSUKUK] = useState<number>(0);
  const [chartOfAccounts, setChartOfAccounts] = useState<any>([]);
  const [counterFundLoading, setCounterFundLoading] = useState(false);

  // Stock market specific states
  const [stockMarketTotal, setStockMarketTotal] = useState<number>(0);
  const [finalStockMarket, setFinalStockMarket] = useState<number>(0);

  useEffect(() => {
    if (amc_code) {
      getFundByAMcCode(amc_code);
    }
    loadTransactionLedgers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, amc_code]);

  const getFundByAMcCode = async (code: string) => {
    setAccFundLoading(true);
    try {
      const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
      const response = await getFundByAmc(
        email,
        code,
        fund_code?.length > 0 ? fund_code : ""
      );
      const sortedData = [...(response.data?.data || [])].sort((a, b) =>
        (a.nature || "").toLowerCase() < (b.nature || "").toLowerCase() ? -1 : 1
      );
      setAllFunds(sortedData);
      setFundCheck(sortedData.length < 1);
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Error fetching funds"
      );
    } finally {
      setAccFundLoading(false);
    }
  };

  const getChartOfAccountsByFundName = async (fund_code: string) => {
    setCounterFundLoading(true);
    try {
      let response = await getNewChartsOfAccountsByFund(
        email,
        amc_code,
        fund_code
      );
      if (response.data.status === 200) {
        setChartOfAccounts(response?.data?.data?.main_family);
      }
    } catch (error) {
      console.error("Error fetching chart of accounts", error);
    } finally {
      setCounterFundLoading(false);
    }
  };

  const loadTransactionLedgers = async () => {
    try {
      const txnResponse = await getTransactionsLedgers(email);
      if (txnResponse?.data?.status === 200) {
        const unitManagement =
          txnResponse.data.data.txn_catagory[4]?.portfolioTxn || [];
        const txnLedgers = unitManagement.filter(
          (item: any) => item.api_name === "dailyportfolioaccrual"
        );
        setTransactionLedgers(txnLedgers);
      } else {
        toast.error("Failed to load transaction ledgers");
      }
    } catch (err: any) {
      console.error("Error loading ledgers:", err);
      toast.error(err?.message || "Failed to load transaction ledgers");
    }
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value);
    resetState();
  };

  const resetState = () => {
    setTableData([]);
    setCalculations({});
    setAffectedLedgerData([]);
    setSendingLedgers([]);
    setTodayPIBTotal(0);
    setTodayTBILLTotal(0);
    setTodayTFCTotal(0);
    setTodaySUKUKTotal(0);
    setFinalPIB(0);
    setFinalTBILL(0);
    setFinalTFC(0);
    setFinalSUKUK(0);
    setStockMarketTotal(0);
    setFinalStockMarket(0);
  };

  // 🔢 Core calculation and ledger generation
  const recalculateLedgers = (data: MoneyMarketItem[]) => {
    const tempCalculations: Calculations = {};
    const affectedTemp: ProcessedLedgerEntry[] = [];
    const sendingTemp: ProcessedLedgerEntry[] = [];

    if (selectedMarket === "stock_market") {
      // Stock Market Logic - Calculate total unrealized gain/loss
      let totalUnrealizedGainLoss = 0;

      data.forEach((item) => {
        const unrealizedGL = parseFloat(item?.unrealized_gain_loss || "0");
        totalUnrealizedGainLoss += unrealizedGL;
      });

      // Round the total
      totalUnrealizedGainLoss = parseFloat(totalUnrealizedGainLoss.toFixed(4));

      tempCalculations["EQUITY"] = totalUnrealizedGainLoss;
      setStockMarketTotal(totalUnrealizedGainLoss);
      setFinalStockMarket(totalUnrealizedGainLoss);

      // Process stock market ledgers
      processStockMarketLedgers(
        totalUnrealizedGainLoss,
        affectedTemp,
        sendingTemp,
        { fund_code: fund, settlement_date: date },
        amc_code,
        fund
      );
    } else {
      // Money Market Logic (existing code)
      data.forEach((item) => {
        const maturityMoment = moment(item?.maturity_date).startOf("day");
        const currentMoment = moment(date).startOf("day");
        const daysofMaturity = maturityMoment.diff(currentMoment, "days");
        const type = item.security_type as SecurityType;
        let accrual = 0;

        switch (type) {
          case "PIB":
            const totalfaceValue = parseFloat(item?.total_face_value || "0");
            const couponRatePIB = parseFloat(item?.coupon_rate || "0") / 100;
            const couponPaymentPIB = parseFloat(item.coupon_payment || "1");
            const couponDaysPIB = parseFloat(item.coupon_days || "365");
            if (couponDaysPIB > 0) {
              accrual =
                (totalfaceValue * (couponRatePIB / couponPaymentPIB)) /
                couponDaysPIB;
            }
            tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
            break;
          case "TDR":
          case "LOP":
          case "CP":
          case "CDR":
            const principalAmmountCDR = parseFloat(
              item?.principal_amount || "0"
            );
            const interestRateCDR = parseFloat(item?.yield || "0") / 100;
            accrual = (principalAmmountCDR * interestRateCDR) / 365;
            tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
            break;
          case "TFC":
          case "Bai Mujjal Placement":
          case "SUKUK":
            const unredeem = parseFloat(
              item.unredeem_value || item.total_face_value || "0"
            );
            const couponRate = parseFloat(item.coupon_rate || "0") / 100;
            const couponPayment = parseFloat(item.coupon_payment || "1");
            const couponDays = parseFloat(item.coupon_days || "365");
            if (couponDays > 0) {
              accrual = (unredeem * (couponRate / couponPayment)) / couponDays;
            }
            tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
            break;
          case "TBILL":
            const faceValue = parseFloat(item.total_face_value || "0");
            const cost = parseFloat(item.total_amount || "0");
            if (+daysofMaturity > 0) {
              accrual = (faceValue - cost) / daysofMaturity;
            }
            tempCalculations[type] = (tempCalculations[type] || 0) + accrual;
            break;
          default:
            break;
        }
      });

      // Round and set totals for money market
      Object.keys(tempCalculations).forEach((key) => {
        const k = key as SecurityType;
        tempCalculations[k] = parseFloat(tempCalculations[k]!.toFixed(4));
      });

      setTodayPIBTotal(tempCalculations["PIB"] || 0);
      setTodayTBILLTotal(tempCalculations["TBILL"] || 0);
      setTodayTFCTotal(tempCalculations["TFC"] || 0);
      setTodaySUKUKTotal(tempCalculations["SUKUK"] || 0);

      setFinalPIB(tempCalculations["PIB"] || 0);
      setFinalTBILL(tempCalculations["TBILL"] || 0);
      setFinalTFC(tempCalculations["TFC"] || 0);
      setFinalSUKUK(tempCalculations["SUKUK"] || 0);

      // Process money market ledgers
      Object.keys(tempCalculations).forEach((typeKey) => {
        const type = typeKey as SecurityType;
        const amount = tempCalculations[type];
        if (amount !== undefined && Math.abs(amount) > 0.0001) {
          processSecurityLedgers(
            type,
            amount,
            transactionLedgers,
            affectedTemp,
            sendingTemp,
            { fund_code: fund, settlement_date: date },
            amc_code,
            fund
          );
        }
      });
    }

    setCalculations(tempCalculations);
    setAffectedLedgerData(affectedTemp);
    setSendingLedgers(sendingTemp);
  };

  const handleGet = async () => {
    if (!fund) return toast.error("Please select a fund.");
    if (!selectedMarket) return toast.error("Please select a market.");

    setLoading(true);
    resetState();

    try {
      const response = await getPortfolioByDate(
        email,
        amc_code,
        fund,
        portfolioDate
      );
      if (response?.data?.status === 404)
        return toast.error("No record found for Today");
      if (response?.data?.status !== 200) throw new Error("Fetch failed");

      const marketKey =
        selectedMarket === "money_market" ? "money_market" : "stock_market";
      const marketData = JSON.parse(response.data.data[0]?.[marketKey] || "[]");

      const filterData =
        selectedMarket === "money_market"
          ? marketData?.filter((ele) => {
              if (
                (ele?.security_type === "CP" ||
                  ele?.security_type === "TDR" ||
                  ele?.security_type === "CDR" ||
                  ele?.security_type === "LOP") &&
                ele?.principal_amount > 0
              ) {
                return true;
              } else if (ele?.units > 0) {
                return true;
              } else {
                return false;
              }
            })
          : marketData;

      if (!filterData.length) {
        return toast.error("No data found for the selected date!");
      }

      setTableData([...filterData]);
      recalculateLedgers(filterData);
    } catch (err: any) {
      toast.error(err?.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  //  Update coupon rate for a specific index
  const updateCouponRate = (index: number, value: string) => {
    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue < 0 || numValue > 100) return;

    setTableData((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], coupon_rate: numValue.toFixed(4) };
      return updated;
    });
  };

  //  Remove security by index
  const removeSecurityAtIndex = (index: number) => {
    setTableData((prev) => prev.filter((_, i) => i !== index));
  };

  //  Recalculate whenever tableData changes
  useEffect(() => {
    if (fund) getChartOfAccountsByFundName(fund);
    if (tableData.length > 0 && fund) {
      recalculateLedgers(tableData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData, fund]);

  //  Submit handler
  const handleSubmit = async () => {
    if (sendingLedgers.length === 0) return toast.error("No data to submit");

    setLoading(true);

    // Calculate net_amount by summing all credit amounts from sendingLedgers
    const totalNetAmount = sendingLedgers.reduce((sum, ledger) => {
      const credit = parseFloat(ledger.credit_amount) || 0;
      return sum + credit;
    }, 0);

    const fields = {
      amc_code,
      fund_code: fund,
      settlement_date: date,
      txnr_type: "dailyportfolioaccrual",
      instruction_date: moment(date).format("YYYY-MM-DD"),
      execution_date: moment(date).format("YYYY-MM-DD"),
      realized_date: moment(date).format("YYYY-MM-DD"),
      realized: "true",
      email,
      period: sessionStorage.getItem("active_period") || "",
      net_amount: String(totalNetAmount.toFixed(4)),
      ledgers: JSON.stringify(sendingLedgers),
    };

    try {
      const navCheck = await validateFundNav(email, amc_code, fund, date);
      if (navCheck?.data?.status !== 200) {
        return toast.error(navCheck?.data?.message);
      }

      const result = await addMegaTransaction(fields);
      if (result.data.status === 200) {
        sessionStorage.setItem("last_id", result.data.txn_id);
        toast.success("Transaction added successfully!");
        setSendingLedgers([]);
        setAffectedLedgerData([]);
        setTableData([]);
        setTimeout(() => history.push("/admin/recent-transactions"), 500);
      } else {
        toast.warning(result.data.message);
      }
    } catch (error: any) {
      toast.error(error?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };

  const handlePortfolioDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPortfolioDate(e.target.value);
  };

  // Updated processStockMarketLedgers function
  const processStockMarketLedgers = (
    unrealizedGainLoss: number,
    affectedTemp: ProcessedLedgerEntry[],
    sendingTemp: ProcessedLedgerEntry[],
    fields: { fund_code: string; settlement_date: string },
    amcCode: string,
    fundCode: string
  ) => {
    const isPositive = unrealizedGainLoss > 0;
    const absAmount = Math.abs(unrealizedGainLoss);
    const dateStr = moment(fields.settlement_date).format("YYYY-MM-DD");
    const desc = `Equity Portfolio Unrealized ${isPositive ? "Gain" : "Loss"}`;

    let debitLedger, creditLedger;

    if (isPositive) {
      // Positive: Debit 10104010102, Credit 50106010101
      debitLedger = createLedgerEntryFromCode(
        "10104010102",
        "Debit",
        absAmount,
        "debit_amount",
        dateStr
      );
      creditLedger = createLedgerEntryFromCode(
        "50106010101",
        "Credit",
        absAmount,
        "credit_amount",
        dateStr
      );
    } else {
      // Negative: Debit 50106010101, Credit 10104010102
      debitLedger = createLedgerEntryFromCode(
        "50106010101",
        "Debit",
        absAmount,
        "debit_amount",
        dateStr
      );
      creditLedger = createLedgerEntryFromCode(
        "10104010102",
        "Credit",
        absAmount,
        "credit_amount",
        dateStr
      );
    }

    if (!debitLedger || !creditLedger) {
      console.error(" Required GL codes not found for EQUITY");
      return;
    }

    // Add description to ledgers
    debitLedger.description = desc;
    creditLedger.description = desc;

    affectedTemp.push(debitLedger, creditLedger);
    sendingTemp.push(debitLedger, creditLedger);
  };

  // Updated createLedgerEntryFromCode function
  const createLedgerEntryFromCode = (
    code: string,
    type: "Debit" | "Credit",
    amount: number,
    amountType: string,
    dateStr: string
  ) => {
    const info: any = getLedgerInfoByLedgerCodeWorking(chartOfAccounts, code);

    if (!info) {
      console.error(` Ledger info not found for code: ${code}`);
      return null;
    }

    return {
      main_family_code: info?.main_family_code || "",
      main_family_name: info?.main_family_name || "",
      family_code: info?.family_code || "",
      family_name: info?.family_name || "",
      sub_family_code: info?.sub_family_code || "",
      sub_family_name: info?.sub_family_name || "",
      child_family_code: info?.child_family_code || "",
      child_family_name: info?.child_family_name || "",
      gl_code: info?.gl_code || code,
      gl_name: info?.gl_name || "",
      amount_type: amountType,
      type: type,
      amc_code: amc_code,
      fund_code: fund,
      account_number: "",
      account_title: "",
      bank_code: "",
      branch: "",
      balance: "",
      counter_account_number: "",
      counter_account_title: "",
      counter_bank: "",
      counter_branch: "",
      credit_amount: type === "Credit" ? amount.toFixed(4) : "0",
      debit_amount: type === "Debit" ? amount.toFixed(4) : "0",
      description: "", // Will be set by calling function
      entered_by: email,
      evidence: "",
      instruction_date: dateStr,
      instrument_by: "",
      instrument_date: dateStr,
      instrument_no: "",
      instrument_type: "",
      realized: "true",
      realized_by: "",
      realized_date: dateStr,
      period: sessionStorage.getItem("active_period") || "",
      paid: false,
      created_at: "",
      doc_type: "",
    };
  };

  // 🔗 Process money market ledgers (existing)
  const processSecurityLedgers = (
    type: SecurityType,
    amount: number,
    ledgersConfig: any[],
    affectedTemp: ProcessedLedgerEntry[],
    sendingTemp: ProcessedLedgerEntry[],
    fields: { fund_code: string; settlement_date: string },
    amcCode: string,
    fundCode: string
  ) => {
    const config = ledgersConfig.find(
      (item) => item.security === type && item.payment_type === "Receipt"
    );
    if (!config) return;

    const debitLedger = config.ledgers?.find((l: any) => l.type === "Debit");
    const creditLedger = config.ledgers?.find((l: any) => l.type === "Credit");
    if (!debitLedger || !creditLedger) return;

    const absAmount = Math.abs(amount).toFixed(4);
    const desc = `${type} Accrual`;

    const newDebit: ProcessedLedgerEntry = getLedgerEntry(
      { amcCode, fundCode, date, absAmount, email, desc },
      debitLedger,
      "debit"
    );
    const newCredit: ProcessedLedgerEntry = getLedgerEntry(
      { amcCode, fundCode, date, absAmount, email, desc },
      creditLedger,
      "credit"
    );

    affectedTemp.push(newDebit, newCredit);
    sendingTemp.push(newDebit, newCredit);
  };

  const renderFundsDropdown = useMemo(
    () =>
      allFunds.map((item) => ({
        value: item.symbol_code,
        label: `${item.fund_name} (${item.symbol_code})${
          item.nature === "Special Managed Account" ? ' - {"SMA"}' : ""
        }`,
      })),
    [allFunds]
  );

  const selectedFundName = useMemo(
    () => renderFundsDropdown.find((f: any) => f.value === fund) || null,
    [fund, renderFundsDropdown]
  );

  const selectedMarketVal = useMemo(
    () => SecurityArr?.find((f: any) => f.value === selectedMarket) || null,
    [selectedMarket]
  );

  return {
    loading,
    accFundLoading,
    allFunds,
    fund,
    setSelectedMarket,
    selectedMarket,
    selectedMarketVal,
    setFund,
    date,
    portfolioDate,
    handleDateChange,
    resetState,
    tableData,
    calculations,
    affectedLedgerData,
    sendingLedgers,
    fundCheck,
    todayPIBTotal,
    todayTBILLTotal,
    todayTFCTotal,
    todaySUKUKTotal,
    finalPIB,
    finalTBILL,
    finalTFC,
    finalSUKUK,
    stockMarketTotal,
    finalStockMarket,
    handleGet,
    handleSubmit,
    renderFundsDropdown,
    selectedFundName,
    numberWithCommas: (val: number | string) =>
      formatNumberWithCommas(parseFloat(val.toString()).toFixed(4)),
    updateCouponRate,
    removeSecurityAtIndex,
    handlePortfolioDate,
  };
};

const getLedgerEntry = (
  relatedData: any,
  data: any,
  type: "debit" | "credit"
) => {
  return {
    account_number: "",
    account_title: "",
    amc_code: relatedData.amcCode,
    bank_code: "",
    branch: "",
    child_family_code: data.ledger_root?.[0]?.child_family_code || "",
    child_family_name: data.ledger_root?.[0]?.child_family_name || "",
    counter_account_number: "",
    counter_account_title: "",
    counter_bank: "",
    counter_branch: "",
    created_at: "",
    credit_amount: type === "credit" ? relatedData.absAmount : "0",
    debit_amount: type === "debit" ? relatedData.absAmount : "0",
    description: relatedData.desc,
    doc_type: "",
    entered_by: relatedData.email,
    evidence: "",
    family_code: data.ledger_root?.[0]?.family_code || "",
    family_name: data.ledger_root?.[0]?.family_name || "",
    fund_code: relatedData.fundCode,
    gl_code: data.ledger_root?.[0]?.gl_code || "",
    gl_name: data.ledger_root?.[0]?.gl_name || "",
    instruction_date: moment(relatedData.date).format("YYYY-MM-DD"),
    instrument_by: "",
    instrument_date: moment(relatedData.date).format("YYYY-MM-DD"),
    instrument_no: "",
    instrument_type: "",
    main_family_code: data.ledger_root?.[0]?.main_family_code || "",
    main_family_name: data.ledger_root?.[0]?.main_family_name || "",
    realized: "true",
    realized_by: "",
    realized_date: moment(relatedData.date).format("YYYY-MM-DD"),
    sub_family_code: data.ledger_root?.[0]?.sub_family_code || "",
    sub_family_name: data.ledger_root?.[0]?.sub_family_name || "",
  };
};

export default usePortfolioAccrual;
